export default {
 documents: {
    list: [],
    total: 0
  },
  
  
  currentDocument: {}
}
